import { render, staticRenderFns } from "./Classifica.vue?vue&type=template&id=446e2650&scoped=true&"
import script from "./Classifica.vue?vue&type=script&lang=js&"
export * from "./Classifica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446e2650",
  null
  
)

export default component.exports